import store from '../store';
import pokedex from "./pokedex";
// import React from "react";

// const weatherEnum = ['None', 'Clear', 'Rainy', 'Partly Cloudy', 'Overcast', 'Windy', 'Snow', 'Fog'];
const weatherBoost = [
	[],
	['Grass', 'Fire', 'Ground'], // Clear
	['Water', 'Electric', 'Bug'], // Rainy
	['Normal', 'Rock'], // Partly Cloudy
	['Fairy', 'Fighting', 'Poison'], // Overcast
	['Flying', 'Dragon', 'Psychic'], // Windy
	['Ice', 'Steel'], // Snow
	['Dark', 'Ghost'] // Fog
];

export function getWeatherForCell(s2Cell) {
	const state = store.getState();
	if( !state.core.weather )
		return null;

	const weatherKey = Object.keys(state.core.weather).find(cellId => Math.abs(parseInt(s2Cell) - parseInt(cellId)) < 0.0000000000001);
	if( !weatherKey )
		return null;

	let weather = state.core.weather[weatherKey];
	if( weather === undefined )
		return 0;

	return weather;
}

export function getWeatherBoosts(s2Cell) {
	const weather = getWeatherForCell(s2Cell);
	return weatherBoost[weather];
}

export function pokemonIsWeatherBoosted(pokemonId, s2Cell) {
	const weather = getWeatherForCell(s2Cell);
	let boosts = weatherBoost[weather];
	let pokemon = pokedex[pokemonId];
	if( !pokemon || !boosts )
		return false;

	if( pokemon['type1'] && (boosts.includes(pokemon['type1'])) )
		return weather;

	if( pokemon['type2'] && (boosts.includes(pokemon['type2'])) )
		return weather;

	return false;
}